<script setup lang="ts">
import ButtonClose from '@/components/button/ButtonClose.vue'
import {
    alertMessageEmptyHappy,
    alertMessageHappy,
    showAlertMessageHappy
} from '@/happyTheme/event/dashboard/alert/AlertMessageHappy'

function toggleAlertMessageHappy() {
    showAlertMessageHappy.value = !showAlertMessageHappy.value
    setTimeout(() => {
        alertMessageHappy.value = alertMessageEmptyHappy
    }, 300)
}
</script>

<template>
    <section class="section-alert-message-dashboard-happy">
        <section
            class="alert-message-dashboard-overlay-happy"
            @click="toggleAlertMessageHappy()"
        ></section>

        <Transition
            name="message-happy"
            enter-active-class="transition-all duration-300 ease-out"
            enter-from-class="translate-x-full"
            enter-to-class="translate-x-0"
            leave-active-class="transition-all duration-300 ease-in"
            leave-from-class="translate-x-0"
            leave-to-class="translate-x-full"
        >
            <section
                v-if="
                    alertMessageHappy.errors &&
                    alertMessageHappy.errors.length !== 0 &&
                    showAlertMessageHappy
                "
                class="section-alert-message-content-dashboard-happy"
            >
                <div
                    class="div-alert-message-content-dashboard-happy"
                    :class="`div-content-message-content-dashboard-happy-${alertMessageHappy.class}`"
                >
                    <h4 class="h4-alert-message-dashboard-happy">
                        {{ alertMessageHappy.title }}
                    </h4>
                    <ButtonClose
                        :function="toggleAlertMessageHappy"
                        :hover-color="
                            alertMessageHappy.class === 'success'
                                ? 'success-happy'
                                : 'error-happy'
                        "
                    />
                </div>
                <div
                    class="div-alert-message-second-content-errors-dashboard-happy"
                    :class="alertMessageHappy.class"
                >
                    <p
                        v-for="(error, i) in alertMessageHappy.errors"
                        :key="i"
                        class="bullet"
                    >
                        {{ error }}
                    </p>
                </div>
            </section>

            <section
                class="section-alert-message-content-dashboard-happy"
                v-else-if="
                    showAlertMessageHappy &&
                    alertMessageHappy.errors &&
                    alertMessageHappy.errors.length === 0
                "
            >
                <div
                    class="div-alert-message-content-dashboard-happy"
                    :class="`div-content-message-content-dashboard-happy-${alertMessageHappy.class}`"
                >
                    <h4 class="h4-alert-message-dashboard-happy">
                        {{ alertMessageHappy.title }}
                    </h4>
                    <ButtonClose
                        :function="toggleAlertMessageHappy"
                        :hover-color="
                            alertMessageHappy.class === 'success'
                                ? 'success-happy'
                                : 'error-happy'
                        "
                    />
                </div>

                <div
                    class="div-alert-message-second-content-dashboard-happy"
                    :class="alertMessageHappy.class"
                >
                    <p class="p-alert-message-dashboard-happy">
                        {{ alertMessageHappy.message }}
                    </p>
                </div>
            </section>
        </Transition>
    </section>
</template>

<style scoped>
.section-alert-message-dashboard-happy {
    @apply fixed top-0 left-0 w-full h-full z-40 flex justify-center;
}

.alert-message-dashboard-overlay-happy {
    @apply w-full h-full bg-text-dark-happy-light opacity-20;
}
.section-alert-message-content-dashboard-happy {
    @apply z-50 absolute min-w-72 max-w-[22rem] flex flex-col justify-center mt-52;
}
.div-alert-message-content-dashboard-happy {
    @apply w-full h-full rounded-t-md flex justify-between items-center gap-2 p-3 shadow shadow-text-dark-happy-light;
}
.div-content-message-content-dashboard-happy-success {
    @apply bg-green-light-happy;
}
.div-content-message-content-dashboard-happy-error {
    @apply bg-header-red-happy;
}

.div-alert-message-second-content-dashboard-happy {
    @apply w-full h-full rounded-b-md px-3 py-4 text-center shadow shadow-text-dark-happy-light;
}
.div-alert-message-second-content-errors-dashboard-happy {
    @apply w-full h-full rounded-b-md px-3 py-4 shadow shadow-text-dark-happy-light;
}

.success {
    @apply bg-green-happy text-text-dark-happy-light;
}
.error {
    @apply bg-border-red-happy-light  text-bg-happy-light;
}

.h4-alert-message-dashboard-happy {
    @apply font-semibold text-start text-text-dark-happy-light;
}
.h4-alert-message-dashboard-happy-error {
    @apply text-bg-happy-light;
}

.p-alert-message-dashboard-happy {
    @apply text-base font-medium text-center;
}

.bullet {
    @apply relative pl-4;
}

.bullet::before {
    content: '•';
    position: absolute;
    left: 0;
}
</style>
